import { type IdeaUserAttributes } from './generated/IdeaUserAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface IdeaUser extends IdeaUserAttributes {}

@model
class IdeaUser extends ApplicationModel {
  // Start auto-generated
  static typename: 'IdeaUser' = 'IdeaUser';
  get typename(): 'IdeaUser' {
    return 'IdeaUser';
  }

  static internalTypename: 'Ideas::IdeaUser' = 'Ideas::IdeaUser';
  get internalTypename(): 'Ideas::IdeaUser' {
    return 'Ideas::IdeaUser';
  }

  static fields = {
    email: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
  };
  // End auto-generated
}

export default IdeaUser;
